export default {
      id: "zoom-out-24-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "assets/iconset.svg#zoom-out-24",
      toString: function () {
        return this.url;
      }
    }